"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var notification = document.createElement("div");
    notification.classList.add("notification", type);
    notification.style.top = posTop + "px";
    notification.style.right = posRight + "px";
    var titleEl = document.createElement("h2");
    titleEl.classList.add("title");
    titleEl.textContent = title;
    var descEl = document.createElement("p");
    descEl.textContent = description;
    notification.appendChild(titleEl);
    notification.appendChild(descEl);
    document.body.appendChild(notification);
    setTimeout(function() {
        notification.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.871bfad5.js.map
